<template>
  <div class="wrapGridArea">
    <div class="title">합계/소계 그리드 <span style="font-size:12px; color: #aaa; font-style: italic;">정렬 상태를 수정하여 결과를 확인할 수 있습니다.</span></div>
    <span>정렬 상태설정 : </span>
    <select id="totalStatus" onChange="totalStatusChanged(value)">
      <option value="none">기본</option>
      <option value="top">상단</option>
      <option value="bottom">하단</option>
    </select>
    <SBGrid
      id="grid"
      style="width: 100%; height: 550px"
      ref="grid"
      :data="gridJson"
      :columns="grid1columns"
      :gridattr="{
        backcoloralternate: '#efefef',
        rowheight: '26',
        rowheader: 'seq',
        selectmode:'free',
        mergecells:'bycol',
        saveorgdata: true
      }"
    ></SBGrid>
  </div>
</template>

<script>
import SBGrid from '../SBGrid.vue'
export default {
  data: function() {
    return {
      gridJson: [
        {"col0":"수입","col1":"매출","col2":"음식판매수입","col3":"10000","col4":"20000","col5":"1522","col6":"11","col7":"600","col8":"550","col9":"800","col10":"650.00","col11":"650.00","col12":"610.00","col13":"650.00","col14":"150.00","col15":""},
        {"col0":"수입","col1":"매출","col2":"농산물판매수입","col3":"11000","col4":"22000","col5":"1622","col6":"12","col7":"670","col8":"550","col9":"800","col10":"650.00","col11":"650.00","col12":"620.00","col13":"650.00","col14":"250.00","col15":""},
        {"col0":"수입","col1":"매출","col2":"농산물가공수입","col3":"10000","col4":"20000","col5":"1522","col6":"11","col7":"600","col8":"550","col9":"800","col10":"650.00","col11":"650.00","col12":"630.00","col13":"650.00","col14":"350.00","col15":""},
        {"col0":"수입","col1":"매출","col2":"음식판매수입","col3":"10000","col4":"20000","col5":"1522","col6":"11","col7":"600","col8":"550","col9":"800","col10":"650.00","col11":"650.00","col12":"640.00","col13":"650.00","col14":"450.00","col15":""},
        {"col0":"수입","col1":"매출","col2":"농산물판매수입","col3":"10000","col4":"20000","col5":"1522","col6":"11","col7":"600","col8":"550","col9":"800","col10":"650.00","col11":"650.00","col12":"650.00","col13":"650.00","col14":"550.00","col15":""},
        {"col0":"수입","col1":"매출","col2":"농산물가공수입","col3":"10000","col4":"20000","col5":"1522","col6":"11","col7":"600","col8":"550","col9":"800","col10":"650.00","col11":"650.00","col12":"660.00","col13":"650.00","col14":"650.00","col15":""},
        {"col0":"수입","col1":"매출","col2":"기타수입","col3":"10000","col4":"20000","col5":"1522","col6":"11","col7":"600","col8":"550","col9":"800","col10":"650.00","col11":"650.00","col12":"670.00","col13":"650.00","col14":"750.00","col15":""},
        {"col0":"수입","col1":"영업외수입","col2":"이자수입","col3":"10000","col4":"20000","col5":"1522","col6":"11","col7":"600","col8":"550","col9":"800","col10":"650.00","col11":"650.00","col12":"680.00","col13":"650.00","col14":"850.00","col15":""},
        {"col0":"지출","col1":"매출원가","col2":"체험재료비","col3":"10000","col4":"20000","col5":"1522","col6":"11","col7":"600","col8":"550","col9":"800","col10":"650.00","col11":"650.00","col12":"690.00","col13":"650.00","col14":"950.00","col15":""},
        {"col0":"지출","col1":"매출원가","col2":"체험인건비","col3":"10000","col4":"20000","col5":"1522","col6":"11","col7":"600","col8":"550","col9":"800","col10":"650.00","col11":"650.00","col12":"600.00","col13":"650.00","col14":"1050.00","col15":""},
        {"col0":"지출","col1":"판매관리비","col2":"급여","col3":"10000","col4":"20000","col5":"1522","col6":"11","col7":"600","col8":"550","col9":"800","col10":"650.00","col11":"650.00","col12":"610.00","col13":"650.00","col14":"1150.00","col15":""},
        {"col0":"지출","col1":"판매관리비","col2":"보험료","col3":"10000","col4":"20000","col5":"1522","col6":"11","col7":"600","col8":"550","col9":"800","col10":"650.00","col11":"650.00","col12":"620.00","col13":"650.00","col14":"1250.00","col15":""},
        {"col0":"지출","col1":"판매관리비","col2":"복리후생","col3":"10000","col4":"20000","col5":"1522","col6":"11","col7":"600","col8":"550","col9":"800","col10":"650.00","col11":"650.00","col12":"630.00","col13":"650.00","col14":"1350.00","col15":""},
      ],
      grid1columns: [
        {caption : ['구분'],  ref : "col0",       width : '100px',        style : 'text-align:center',    type : 'input'},
        {caption : ['분류'],  ref : "col1",       width : '100px',        style : 'text-align:center',    type : 'input'},
        {caption : ['항목'],  ref : "col2",       width : '150px',        style : 'text-align:center',    type : 'input'},
        {caption : ['1월'],  ref : "col3",       width : '100px',        style : 'text-align:right', type : 'input',     format : { type:'number' , rule:'#,##0.00' }, merge:false},
        {caption : ['2월'],  ref : "col4",       width : '100px',        style : 'text-align:right', type : 'input',     format : { type:'number' , rule:'#,##0.00' }, merge:false},
        {caption : ['3월'],  ref : "col5",       width : '100px',        style : 'text-align:right', type : 'input',     format : { type:'number' , rule:'#,##0.00' }, merge:false},
        {caption : ['4월'],  ref : "col6",       width : '100px',        style : 'text-align:right', type : 'input',     format : { type:'number' , rule:'#,##0.00' }, merge:false},
        {caption : ['5월'],  ref : "col7",       width : '100px',        style : 'text-align:right', type : 'input',     format : { type:'number' , rule:'#,##0.00' }, merge:false},
        {caption : ['6월'],  ref : "col8",       width : '100px',        style : 'text-align:right', type : 'input',     format : { type:'number' , rule:'#,##0.00' }, merge:false},
        {caption : ['7월'],  ref : "col9",       width : '100px',        style : 'text-align:right', type : 'input',     format : { type:'number' , rule:'#,##0.00' }, merge:false},
        {caption : ['8월'],  ref : "col10",  width : '100px',        style : 'text-align:right', type : 'input',     format : { type:'number' , rule:'#,##0.00' }, merge:false},
        {caption : ['9월'],  ref : "col11",  width : '100px',        style : 'text-align:right', type : 'input',     format : { type:'number' , rule:'#,##0.00' }, merge:false},
        {caption : ['10월'],  ref : "col12",  width : '100px',        style : 'text-align:right', type : 'input',     format : { type:'number' , rule:'#,##0.00' }, merge:false},
        {caption : ['11월'],  ref : "col13",  width : '100px',        style : 'text-align:right', type : 'input',     format : { type:'number' , rule:'#,##0.00' }, merge:false},
        {caption : ['12월'],  ref : "col14",  width : '100px',        style : 'text-align:right', type : 'input',     format : { type:'number' , rule:'#,##0.00' }, merge:false},
      ]
    }
  },
  components: {
    SBGrid
  },
}
window.totalStatusChanged = function(value) {
  if(value == "none") {
    window.vl.$refs.view.$refs.grid.gridObject.clearTotal();
  } else {
    let objTotal = {
    type        : 'subgrand',
    position    : value,
    standardvaluechange : true,
    columns     : {
      standard : [1,2],
        sum : [4,5,6,7,8,9,10,11,12,13,14,15]
    },
    subtotalrow : {
      1 : {
        titlecol    : 2,
            titlevalue  : '@ 소계',
            style : 'background-color: rgb(146, 178, 197); font-weight: bold; color: rgb(255, 255, 255);',
            stylestartcol   : 2
        },
        2 : {
          titlecol    : 3,
            titlevalue  : '@ 소계',
            style : 'background-color: rgb(146, 178, 197); font-weight: bold; color: rgb(255, 255, 255);',
            stylestartcol   : 3
        }
    },
    grandtotalrow : {
        titlecol    : 1,
        titlevalue  : '합계',
        style : 'background-color: rgb(146, 178, 197); font-weight: bold; color: rgb(255, 255, 255);',
        stylestartcol   : 1
    },
    datasorting : true
  };
  window.vl.$refs.view.$refs.grid.gridObject.setTotal(objTotal);
  }
}
</script>

<style>
</style>